import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    StripeProvider,
    Elements,
    injectStripe,
} from 'react-stripe-elements';
import React, {Component} from 'react';
import Loader from 'react-loader-spinner';
import {Tooltip} from 'reactstrap';
import StripeService from "../services/StripeService";
import ReactDOM from "react-dom";
import scrollToComponent from 'react-scroll-to-component';

const createOptions = (fontSize, padding) => {
    return {
        style: {
            base: {
                fontSize,
                fontWeight: '400',
                color: '#424770',
                letterSpacing: '1px',
                '::placeholder': {
                    color: '#aab7c4',
                    fontWeight: '100',
                },
                padding,
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
};


class _SplitForm extends React.Component {
    constructor(props) {
        super(props);

        this.stripeService = new StripeService();

        this.localState = this.props.localState;

        this.state = {
            tooltipOpen: false,
            loading: false,
            name: '',
            paymentSuccess: false,
            paymentError: this.props.paymentError || false,
            paymentMessage: this.props.paymentError || '',
            checked: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxInputChange = this.handleCheckboxInputChange.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
            paymentSuccess: false,
            paymentError: false,
            paymentMessage: '',
        })
    }

    handleCheckboxInputChange(e) {
        this.setState({checked: !this.state.checked})
    }

    handleSubmit(ev) {
        ev.preventDefault();
        const {quote} = this.props;
        let page = window.location.pathname.split('/')[1];

        this.setState({
            paymentSuccess: false,
            paymentError: false,
            message: ''
        });
        if (this.props.stripe) {
            this.setState({loading: true});

            this.props.stripe
                .createToken({name: this.state.name})
                .then((payload) =>  {
                    this.stripeService.executeQuotePayment(quote.id, payload.token)
                        .then((response) => {
                            return window.location.href = response.data.redirect_url;
                        })
                        .catch((err) => {
                            // console.log(err);
                            this.setState({
                                loading: false,
                                paymentError: true,
                                message: err.response.data.message
                            }, () => {
                                if (window.innerWidth <= 760) {
                                    scrollToComponent(this.ResInfo, {
                                        offset: 0,
                                        align: 'middle',
                                        duration: 500,
                                        ease: 'inExpo'
                                    });
                                }
                            });
                        })
                    }
                )
                .catch(err => {
                    this.setState({
                        loading: false,
                        paymentSuccess: true,
                        message: 'Something went wrong.'
                    }, () => {
                        if (window.innerWidth <= 760) {
                            scrollToComponent(this.ResInfo, {
                                offset: 0,
                                align: 'middle',
                                duration: 500,
                                ease: 'inExpo'
                            });
                        }
                    })
                });
        } else {
            console.log("Stripe.js hasn't loaded yet.");
        }
    };

    executeNonStrongPayment() {
        this.props.stripe
            .createToken({name: this.state.name})
            .then((payload) => this.stripeService
                .executeNonStrongPayment(payload.token, this.localState)
                .then((res) => {
                    this.setState({
                        loading: false,
                        paymentSuccess: true,
                        message: res.data.message,
                        checked: false
                    }, () => {
                        let orderId = res.data.order;
                        sessionStorage.clear();
                        if (window.innerWidth <= 760) {
                            scrollToComponent(this.ResInfo, {
                                offset: 0,
                                align: 'middle',
                                duration: 500,
                                ease: 'inExpo'
                            });
                        }
                        setTimeout(function () { //Start the timer
                            window.location.href = `/${orderId}/payment-success` //After 1 second, redirect
                        }, 3000)
                    })
                })
            );
    }



    render() {
        return (
            <section id='payment'>
                <div className='container pb-5'>
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading pt-sm-0 pt-5 px-3">Payment</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-body card-wizard">
                                    <div className='row' ref={(section) => {
                                        this.ResInfo = section;
                                    }}>
                                        <div className="col-md-12">
                                            {this.state.paymentSuccess &&
                                            <div className="alert alert-success">{this.state.message}</div>
                                            }
                                            {this.state.paymentError &&
                                            <div className="alert alert-danger">Wrong card details, please check all the fields and try again</div>
                                            }
                                        </div>
                                    </div>
                                    <form onSubmit={this.handleSubmit} id="stripeForm">
                                        <div className="form-group row">
                                            <div className="col-md-3 payment-name-label">
                                                <label className='wizard-label'>
                                                    <small>Cardholder name <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="text"
                                                       name='name'
                                                       onChange={this.handleInputChange}
                                                       value={this.state.name}
                                                       className='form-control payment-name'
                                                       placeholder='Your name...'/>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-3 col-payment">
                                                <label className='wizard-label'>
                                                    <small>Card number <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardNumberElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-3 col-payment">
                                                <label className='wizard-label'>
                                                    <small>Expiration date <i className='fa fa-asterisk'> </i></small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardExpiryElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>

                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-3 col-payment">
                                                <label className='wizard-label'>
                                                    <small>CVC <i className='fa fa-asterisk'> </i>
                                                        <i className='fa fa-question-circle pl-1'
                                                           id="TooltipExample"> </i>
                                                        <Tooltip placement="right" isOpen={this.state.tooltipOpen}
                                                                 target="TooltipExample" toggle={this.toggle}>
                                                            <div><small>The CVV Number on your credit or debit card is a
                                                                3 digit number located on the back of your card.</small>
                                                            </div>
                                                            <div className='pb-2'><img
                                                                className='img img-fluid img-responsive'
                                                                src="assets/img/cvv-caption_new.png" alt="cvv_image"/>
                                                            </div>
                                                        </Tooltip>
                                                    </small>
                                                </label>
                                            </div>
                                            <div className="col-md-9">
                                                <CardCVCElement
                                                    {...createOptions(this.props.fontSize)}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="text-right col-md-12">
                                                <p style={{color: '#FDB913'}}><strong>Total to
                                                    pay: &#163; {this.props.quote.amount}
                                                </strong>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="form-group text-right">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="checkbox" id="inlineCheckbox1"
                                                       onChange={(e) => this.handleCheckboxInputChange(e)}/>
                                                <label className="form-check-label wizard-label pt-1"
                                                       htmlFor="inlineCheckbox1">
                                                    <small>I agree with <a className="terms-link"
                                                                           href="/terms-and-conditions" target="_blank">Terms
                                                        & Conditions</a></small>
                                                </label>
                                            </div>
                                            <button className='btn btn-round btn-payment'
                                                    onClick={(ev) => this.handleSubmit(ev)}
                                                    disabled={!this.state.checked || this.state.loading}>
                                                <div className='d-flex flex-row justify-content-center'>
                                                    {this.state.loading &&
                                                    <div style={{
                                                        display: 'inline-block',
                                                        paddingRight: '5px',
                                                    }}>
                                                        <Loader type="Oval" color="#514f4c" height={15} width={15}/>
                                                    </div>
                                                    }
                                                    <div>Pay</div>
                                                </div>
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const SplitForm = injectStripe(_SplitForm);

class Checkout extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const fonts = [{cssSrc: "https://fonts.googleapis.com/css?family=Comfortaa:300,400,700"}];
        // const {elementFontSize} = this.state;
        return (
            <div className="Checkout">
                <SplitForm quote={this.props.quote} />
            </div>
        );
    }
}


export default class QuotesPayment extends Component {
    render() {
        const fonts = [{cssSrc: "https://fonts.googleapis.com/css?family=Comfortaa:300,400,700"}];

        return (
            <div>
                <StripeProvider apiKey={this.props.stripe_key}>
                    <Elements fonts={fonts}>
                        <Checkout quote={this.props.quote}/>
                    </Elements>
                </StripeProvider>
            </div>
        );
    }

};

